<template>
    <div>

        <TextBanner>
        <p>Wenn ihre Zeit abgelaufen ist, wird die mehr als 20 Jahre alte ISS <b>kontrolliert</b> in ihren Einzelteilen ins Meer stürzen. 
        Denn als Weltraumschrott ist sie mit ihren mehr als 400 Tonnen zu schwer und zu groß.</p>
        </TextBanner>

        <!-- Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_080_p.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_080_l.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/fallback.jpg" alt="">
            </picture>

        </Fallback>


    </div>
</template>

<script>
    export default {
        name: 'infobox',
        babylonState: {
            camera: {
                position: [-.9,.9,80],   //[1.56,0.1,30],
                target: [.5,-4,2],       //[.5,0,0]
                animationSpeed: 850,
                useAutoRotationBehavior: true,
                idleRotationSpeed: 0.005,
            },

            // zdfLogo: {
            //     ZDF_Logo: {
            //         ZDF_Logo_2: true
            //     }
            // },

            iss: {

                SpaceX_Body: {
                    visible: true,
                    pickable: false,
                    // overlayColor: [20/255, 192/255, 216/255],
                    // overlayAlpha: 0.6,
                    SpaceX_Cargo: {
                        visible: true,
                        pickable: false,
                        // overlayColor: [20/255, 192/255, 216/255],
                        // overlayAlpha: 0.6,
                    },
                    SpaceX_Klappe: {
                        visible: true,
                        pickable: false,
                        // overlayColor: [20/255, 192/255, 216/255],
                        // overlayAlpha: 0.6,
                    }
                },
            },
    
    },
        babylonReady: function () {
        //this.$audioController.initTrack('speaker', require('./../assets/audio/2496003_Starhorizon_192.mp3'), true, false);
        this.$babylonController.goToAnimation("spacex_anim", 100);

        this.$babylonController.timer.add(4500, () => {
            this.$babylonController.setCameraRadiusLimit(30,200);
        });


        },
    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {

        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);
        }
    }


</style>
